import React, { Component } from 'react'
import moment from 'moment'
import { Link } from 'react-router'
import { Col, Image, Carousel} from 'react-bootstrap'
import { translate } from "react-translate"
import SliderSlick from 'react-slick'

import './SliderMarketReports.scss';
import imi from '../../../api/imi'
import { ShareButton } from '../ShareButton/ShareButton.component'

@translate("Imis")
export default class Imis extends Component {

  bannerNext(e) {
    e.preventDefault()
    e.stopPropagation()
    // eslint-disable-next-line react/no-string-refs
    this.refs.sliderImi.slickNext()
  }
  bannerPrevious(e) {
    e.preventDefault()
    e.stopPropagation()
    // eslint-disable-next-line react/no-string-refs
    this.refs.sliderImi.slickPrev()
  }

  _renderDate(date){
    moment.locale('es');
    var m = moment(date, "MM-DD-YYYY")
    let day = moment(m).format('MMMM')
    let year = moment(m).format('YYYY')
    return (<p className="date-reference">{day} {year}</p>)
  }

  _renderStyle(item){
    let image = item.image_circular ? item.image_circular : item.image
    let style = {
      backgroundImage: 'url(' + image + ')'
    }
    return style
  }

  render () {

    const { imis, t } = this.props

    const bannerSettings = {
      dots: false,
      arrows: false,
      speed: 400,
      autoplay: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      touchMove: true,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 2 } },
        { breakpoint: 768, settings: { slidesToShow: 1, dots: true } },
      ]
    }

    if (!imis || !imis.length) { return null }

    return (
      <div className="ljr-slider-container">
        <Link className="btn ljr-slider-view-more-items hidden-xs" to="/informes-del-mercado-inmobiliario">{t("Consultar_todos_los_informes")}</Link>
        <h1>{t("Informes_de_Mercado_Inmobiliario")}</h1>
        <div className="banners-container">
          <SliderSlick className='slider-banners-container' ref='sliderImi' {...bannerSettings}>
            {imis.map((item, index) =>
              <Col md={3} sm={12} key={index} >
                <div className='slider-template-news'>
                  <ShareButton
                    shareUrl={'/informes-del-mercado-inmobiliario/' + item.id}
                  />
                  <div className="slider-image" style={this._renderStyle(item)}>
                    <div className="overlay-img"></div>
                  </div>
                  <div className="slider-item-detail">
                    <Link to={'/informes-del-mercado-inmobiliario/' + item.id}>
                      <h2>{item.title}</h2>
                      <h3>{item.bajada}</h3>
                    </Link>
                    {this._renderDate(item.date)}
                  </div>
                </div>
              </Col>
            )}
          </SliderSlick>
          <div className='ljr-slider-buttons'>
            <div className='ljr-slider-left-buttons'>
              <a onClick={(e) => {this.bannerPrevious(e)}}>
                <i className='fa fa-angle-left fa-2x' aria-hidden='true'></i>
              </a>
            </div>
            <div className='ljr-slider-right-buttons'>
              <a onClick={(e) => {this.bannerNext(e)}}>
                <i className='fa fa-angle-right fa-2x' aria-hidden='true'></i>
              </a>
            </div>
          </div>
          <div className='text-center visible-xs'>
            <Link className="btn ljr-slider-view-more-items-mobile" to="/informes-del-mercado-inmobiliario">{t("Consultar_todos_los_informes")}</Link>
          </div>
        </div>

        {/* <div className="carousel-container visible-xs">
          <Carousel nextIcon={next} prevIcon={prev} indicators={false} >
            {imis.map((item, index) =>
              <Carousel.Item key={index}>
                <div className="imi-img" style={this._renderStyle(item)}>
                  <div className="overlay-img"></div>
                  <Link to={'/informes-del-mercado-inmobiliario/' + item.id} className="hidden-xs">{t("Ver_informe")}</Link>
                </div>
                <div className="imi-info">
                  <h2>{item.title}</h2>
                  <h3>{item.bajada}</h3>
                  <div className="date-separator"></div>
                  <h4>{this._renderDate(item.date)}</h4>
                </div>
              </Carousel.Item>
            )}
          </Carousel>
        </div> */}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/commons/SliderMarketReports/imi.js